<template>
  <div>
    <v-select
      :value="selected_industry"
      :options="industries"
      :searchable="false"
      :clearable="false"
      :components="{ OpenIndicator }"
      @input="setSelected"
    >
    </v-select>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Dropdown",
  data: () => ({
    OpenIndicator: {
      render: createElement =>
        createElement("span", { class: { toggle: true } })
    }
  }),
  computed: {
    ...mapGetters({
      selected_industry: "getSelectedIndustry",
      industries: "getIndustryList"
    })
  },
  methods: {
    ...mapActions({
      setIndustry: "setIndustry"
    }),
    setSelected(value) {
      this.setIndustry(value);
    }
  },
  mounted() {
    this.setIndustry("Apparel");
  }
};
</script>

<style lang="scss"></style>
